import type { TimberItem } from './materialsDatabaseService';

function normalizeSupplierName(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, ' ');
}

/** Species this vendor quotes in the materials database (matched by supplier org name). */
export function speciesProvidedBySupplier(orgName: string, timberItems: TimberItem[]): string[] {
  const target = normalizeSupplierName(orgName);
  if (!target) return [];

  const species = new Set<string>();
  for (const item of timberItems) {
    const itemSpecies = item.species?.trim();
    if (!itemSpecies) continue;

    if (item.supplier && normalizeSupplierName(item.supplier) === target) {
      species.add(itemSpecies);
    }
    for (const sp of item.supplierPricing || []) {
      if (sp.supplier && normalizeSupplierName(sp.supplier) === target) {
        species.add(itemSpecies);
      }
    }
  }

  return Array.from(species).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}
